import type { SiteStore } from '@wix/wixstores-client-storefront-sdk';
import type { BaseActionsParams } from '../../types';

export abstract class BaseActions {
  protected readonly origin: string;
  protected readonly siteStore: SiteStore;

  public constructor({ siteStore, origin }: BaseActionsParams) {
    this.origin = origin;
    this.siteStore = siteStore;
  }
}
